module.exports = __webpack_public_path__ + "resources/img/m-pic-01.47995f26.png";